import React from 'react';
import ReactDOM from 'react-dom';
import { Callout } from '@bingads-webui-react/fabric-control';

export const showDisabledReasonCallout = (i18n, event, element) => {
  if (element) {
    event.stopPropagation();

    ReactDOM.render(
      <Callout
        target={event.target}
        role="alert"
      >
        <div style={{ padding: '10px 12px', backgroundColor: '#666666', color: 'white' }}>
          {i18n.getString('Disabled_System_Generated_Image')}
        </div>
      </Callout>,
      element
    );
  }
};

export const hideDisabledReasonCallout = (element) => {
  if (element) {
    ReactDOM.unmountComponentAtNode(element);
  }
};
